'use client'

import { FieldMappingPanel } from '@repo/formevo-configuration/FieldMappingPanel'
import { SettingsPanel } from '@repo/formevo-configuration/SettingsPanel'
import { WorktypeLinkingPanel } from '@repo/formevo-configuration/WorktypeLinkingPanel'
import { useState } from 'react'
import MUIStack from '@mui/material/Stack'
import MUITab from '@mui/material/Tab'
import MUITabs from '@mui/material/Tabs'

const TABS = {
  settings: 'settings',
  worktypeLinking: 'worktypeLinking',
  fieldMapping: 'fieldMapping'
}

export const FormEvoConfigurationModule = () => {
  const [selectedTab, setSelectedTab] = useState(TABS.settings)

  return (
    <MUIStack data-testid="FormEvoConfigurationModule" gap={4}>
      <MUITabs
        value={selectedTab}
        onChange={(_, value) => setSelectedTab(value)}
        sx={{
          ml: '4rem',
          borderBottom: 'none',
          '& .MuiTabs-flexContainer': {
            borderBottom: 'none'
          }
        }}
      >
        <MUITab value={TABS.settings} label="Settings" />
        <MUITab value={TABS.worktypeLinking} label="Worktype linking" />
        <MUITab value={TABS.fieldMapping} label="Field mapping" />
      </MUITabs>

      {selectedTab === TABS.settings && <SettingsPanel />}
      {selectedTab === TABS.worktypeLinking && <WorktypeLinkingPanel />}
      {selectedTab === TABS.fieldMapping && <FieldMappingPanel />}
    </MUIStack>
  )
}
